import { isBrowser } from '@app/utils';
import QUANTUM_METRIC_EVENT_CODES from './consts/eventCodes';

export default class quantumMetricClient {
  static get isReady() {
    return (
      isBrowser &&
      Object.prototype.hasOwnProperty.call(window, 'QuantumMetricAPI')
    );
  }

  static trackGenericError(errorMsg, userConverted = 0) {
    if (!this.isReady) {
      return;
    }

    window?.QuantumMetricAPI?.sendEvent(
      QUANTUM_METRIC_EVENT_CODES.GENERIC_ERROR,
      userConverted,
      errorMsg,
    );
  }
}
